import { globalTypes } from '../types';
import { reduceAction } from '../helpers';

import types from './types';
import { compareExpandedAccordionsGroup } from './helpers';

export const initialState = () => ({
    windowSize: {
        width: window.innerWidth,
        height: window.innerHeight,
    },
    visibleElements: [],
    miniCartPopover: {
        isOpened: false,
        productCode: '',
        quantityAdded: 0,
        isDisabled: false,
        statusCode: '',
    },
    loginPopoverOpened: false,
    miniCartForcedMessages: [],
    dialog: { content: '' },
    [types.OPEN_MODAL]: null,
    lang: 'en1',
    filtersMenuDisplayed: false,
    linkableTab: null,
    accountNav: {
        tree: [],
    },
    isNavigationOpened: false,
    isMyAccountNavigationOpened: false,
    needsFlyDownEffect: true,
    preventClick: false,
    scrollTop: false,
    headerScrolled: false,
    accordionOpened: [],
    facetSearchValue: '',
    openReviewsWrapper: false,
    pageViewType: false,
    scrollGroupAnchor: '',
    plpViewType: {},
    contentItemsAmount: 0,
    customHandleClose: false,
    mouseDeltaCoordinatesX: {
        x0: 0,
        x1: 0,
    },
    pageScrolledDown: false,
    hoveredGWPProduct: '',
    elementsToRefresh: [],
    bvInitialized: false,
    showAddVoucherForm: false,
    activeAlphabetFilters: {},
    contentViewChanged: false,
    expandedAccordionGroups: {},
    connectedAndShow: {
        container: {},
    },
    collapsibleItems: {},
    registeredIframes: [],
    isStickyBarExpanded: {},
});

const reducers = (state = initialState(), action) => {
    const { payload } = action;
    switch (action.type) {
        case globalTypes.INITIALIZE:
            return initialState();

        case types.ADD_TO_VISIBLE_ELEMENTS: {
            if (state.visibleElements.includes(payload)) {
                return state;
            }
            return {
                ...state,
                visibleElements: [...state.visibleElements, payload],
            };
        }

        case types.REMOVE_FROM_VISIBLE_ELEMENTS: {
            const visibleElements = state.visibleElements.filter(trackId => trackId !== payload);
            return {
                ...state,
                visibleElements,
            };
        }

        case types.SET_WINDOW_SIZE:
            return reduceAction(state, 'windowSize', payload);

        case types.CLEAR_PINCODE:
            return reduceAction(state, 'clearPincode', action.payload);

        case types.SET_MINICART_POPOVER_DATA:
            return {
                ...state,
                miniCartPopover: {
                    ...state.miniCartPopover,
                    ...(payload || {}),
                },
            };

        case types.SET_LOGIN_POPOVER_OPENED:
            return reduceAction(state, 'loginPopoverOpened', payload);

        case types.SET_SCROLL_TOP:
            return reduceAction(state, 'scrollTop', action.payload);

        case types.SET_MINICART_FORCED_MESSAGES:
            return reduceAction(state, 'miniCartForcedMessages', payload || []);

        case types.REMOVE_MINICART_FORCED_MESSAGES:
            return state.miniCartForcedMessages.length
                ? { ...state, miniCartForcedMessages: [] }
                : state;

        case types.TOOGLE_MINICART_POPOVER_DATA:
            return {
                ...state,
                miniCartPopover: {
                    ...state.miniCartPopover,
                    ...(payload || {}),
                },
            };
        case types.FORCE_CLOSE_MINICART_POPOVER:
            return {
                ...state,
                miniCartPopover: {
                    ...state.miniCartPopover,
                    isOpened: false,
                },
            };

        case types.BV_INITIALIZE:
            return reduceAction(state, 'bvInitialized', true);

        case types.OPEN_MODAL:
            return reduceAction(state, types.OPEN_MODAL, payload);

        case types.OPEN_DIALOG:
            return {
                ...state,
                dialog: {
                    ...state.dialog,
                    opened: payload.name || null,
                    iframeUrl: payload.iframeUrl || null,
                    iframeRedirectOnClose: payload.iframeRedirectOnClose || null,
                    content: payload.content || '',
                },
            };

        case types.CLOSE_DIALOG:
            return {
                ...state,
                dialog: {
                    ...state.dialog,
                    opened: null,
                    iframeUrl: null,
                    iframeRedirectOnClose: null,
                    content: '',
                },
            };

        case types.HIDE_FILTERS_MENU:
            return reduceAction(state, 'filtersMenuDisplayed', false);

        case types.SHOW_FILTERS_MENU:
            return reduceAction(state, 'filtersMenuDisplayed', true);

        case types.SET_LANG:
            return reduceAction(state, 'lang', payload);

        case types.STORE_INFO_STATUS:
            return reduceAction(state, 'storeInfoPopupOpened', payload);

        case types.SET_NAVIGATION:
            return reduceAction(state, 'isNavigationOpened', payload);

        case types.SET_MY_ACCOUNT_NAVIGATION:
            return {
                ...state,
                isMyAccountNavigationOpened: !state.isMyAccountNavigationOpened,
            };

        case types.OPEN_TAB:
            return {
                ...state,
                tabName: typeof payload === 'object' && payload !== null ? payload.name : payload,
            };

        case types.ADD_ACCOUNT_NAVIGATION:
            if (state.accountNav.tree.find(node => node.title === payload.title)) {
                return state;
            }
            return {
                ...state,
                accountNav: {
                    ...state.accountNav,
                    tree: [...state.accountNav.tree, payload],
                },
            };

        case types.SET_ACCOUNT_NAVIGATION_ACTIVE:
            return {
                ...state,
                accountNav: {
                    ...state.accountNav,
                    active: payload,
                },
            };

        case types.ADD_TAB_LINK:
            return reduceAction(state, 'linkableTab', payload);
        case types.SET_FLY_DOWN_EFFECT:
            return reduceAction(state, 'needsFlyDownEffect', false);
        case types.RESET_FLY_DOWN_EFFECT:
            return reduceAction(state, 'needsFlyDownEffect', true);

        case types.SET_HOVERED_MINI_CART_PRODUCT:
            return {
                ...state,
                miniCartPopover: {
                    ...state.miniCartPopover,
                    hoveredMiniCartProduct: payload,
                },
            };
        case types.ACCORDION_OPEN:
            return {
                ...state,
                accordionOpened: [
                    ...state.accordionOpened.filter(i => i.groupName !== payload.groupName),
                    payload,
                ],
            };

        case types.ACCORDION_CLOSE:
            return {
                ...state,
                accordionOpened: [...state.accordionOpened.filter(i => i.name !== payload.name)],
            };

        case types.ADD_ELEMENTS_TO_REFRESH: {
            const newElements = Array.isArray(action.payload) ? action.payload : [action.payload];
            return {
                ...state,
                elementsToRefresh: [...state.elementsToRefresh, ...newElements],
            };
        }

        case types.REMOVE_ELEMENT_TO_REFRESH:
            return {
                ...state,
                elementsToRefresh: state.elementsToRefresh.filter(id => id !== payload),
            };

        case types.PREVENT_CLICK:
            return reduceAction(state, 'preventClick', action.payload);

        case types.VARIANT_SELECT_STATUS:
            return reduceAction(state, 'openVariantSelectStatus', action.payload);

        case types.SET_HEADER_SCROLLED:
            return reduceAction(state, 'headerScrolled', action.payload);

        case types.SET_PAGE_SCROLLED_DOWN:
            return reduceAction(state, 'pageScrolledDown', action.payload);

        case types.SET_FACET_SEARCH_VALUE:
            return reduceAction(state, 'facetSearchValue', action.payload);

        case types.OPEN_REVIEWS_WRAPPER:
            return reduceAction(state, 'openReviewsWrapper', true);

        case types.CLOSE_REVIEWS_WRAPPER:
            return reduceAction(state, 'openReviewsWrapper', false);

        case types.SET_AUTO_LOGIN_MESSAGE:
            return reduceAction(state, 'autoLoginMessage', action.payload);

        case types.SET_PAGE_VIEW_TYPE:
            return {
                ...state,
                pageViewType: (action.payload && action.payload.value) || action.payload,
            };

        case types.RESET_PAGE_VIEW_TYPE:
            return reduceAction(state, 'pageViewType', false);

        case types.SCROLL_TO_ANCHOR_GROUP:
            return reduceAction(state, 'scrollGroupAnchor', action.payload);

        case types.RESET_SCROLL_ANCHOR_GROUP:
            return reduceAction(state, 'scrollGroupAnchor', '');

        case types.SET_PLP_VIEW_TYPES:
            return reduceAction(state, 'plpViewType', payload);

        case types.SET_PLP_VIEW_TYPE:
            return {
                ...state,
                plpViewType: {
                    ...state.plpViewType,
                    [payload.id || 'default']: payload.type,
                },
            };

        case types.SET_CONTENT_ITEMS_AMOUNT:
            return reduceAction(state, 'contentItemsAmount', action.payload);

        case types.STICKY_BAR_TOGGLE:
            return {
                ...state,
                isStickyBarExpanded: {
                    ...state.isStickyBarExpanded,
                    [payload.id || 'default']: !state.isStickyBarExpanded[payload.id || 'default'],
                },
            };

        case types.SET_CUSTOM_HANDLE_CLOSE:
            return reduceAction(state, 'customHandleClose', action.payload);

        case types.TOP_BRANDS_SHOW:
            return reduceAction(state, 'isTopBrandsShown', true);

        case types.TOP_BRANDS_HIDE:
            return reduceAction(state, 'isTopBrandsShown', false);

        case types.CLEAR_STATUS_CODE:
            return {
                ...state,
                miniCartPopover: { ...state.miniCartPopover, statusCode: '' },
            };

        case types.NEWSLETTER_DISCLAIMER_SHOW:
            return reduceAction(state, 'isNewsletterDisclaimerShown', true);

        case types.SET_HOVERED_GWP_PRODUCT:
            return reduceAction(state, 'hoveredGWPProduct', action.payload);

        case types.SHOW_ADD_VOUCHER_FORM:
            return reduceAction(state, 'showAddVoucherForm', true);

        case types.HIDE_ADD_VOUCHER_FORM:
            return reduceAction(state, 'showAddVoucherForm', false);

        case types.SET_ACTIVE_ALPHABET_FILTER:
            return {
                ...state,
                activeAlphabetFilters: {
                    ...state.activeAlphabetFilters,
                    ...(state.activeAlphabetFilters[payload.value] = payload.enabled),
                },
            };
        case types.CLEAR_ACTIVE_ALPHABET_FILTER:
            return { ...state, activeAlphabetFilters: {} };

        case types.CONTENT_VIEW_CHANGED:
            return reduceAction(state, 'contentViewChanged', action.payload);

        case types.EXPAND_ACCORDION:
            return {
                ...state,
                expandedAccordionGroups: {
                    [action.payload.groupName]: {
                        ...state.expandedAccordionGroups[action.payload.groupName],
                        [action.payload.id]: action.payload.status,
                    },
                },
            };

        case types.COMPARE_EXPANDED_ACCORDIONS_GROUP:
            return {
                ...state,
                expandedAccordionGroups: {
                    [action.payload.groupName]: compareExpandedAccordionsGroup(
                        action.payload.list,
                        state.expandedAccordionGroups[action.payload.groupName],
                    ),
                },
            };

        case types.RESET_EXPANDED_ACCORDIONS:
            return {
                ...state,
                expandedAccordionGroups: {
                    [action.payload.groupName]: {},
                },
            };

        case types.CONNECTED_AND_SHOW:
            return {
                ...state,
                connectedAndShow: {
                    ...state.connectedAndShow,
                    [action.payload.id]: action.payload.show,
                },
            };
        case types.CONNECTED_AND_SHOW_CONTAINER:
            return {
                ...state,
                connectedAndShow: {
                    ...state.connectedAndShow,
                    container: {
                        ...state.connectedAndShow.container,
                        [action.payload.container]: {
                            ...state.connectedAndShow.container[action.payload.container],
                            [action.payload.id]: !!action.payload.show,
                        },
                    },
                },
            };
        case types.FORCE_CLICK_AVAILABILITY_IN_BRANCH:
            return {
                ...state,
                realTimeStock: {
                    ...payload,
                },
            };
        case types.SET_MIN_ITEMS_TO_SHOW:
            return {
                ...state,
                collapsibleItems: {
                    ...state.collapsibleItems,
                    [action.payload.itemsUid]: {
                        minItemsToShow: action.payload.minItemsToShow,
                    },
                },
            };
        case types.REGISTER_IFRAME:
            return {
                ...state,
                registeredIframes: [
                    ...state.registeredIframes.filter(i => i.iframeId !== action.payload.iframeId),
                    action.payload,
                ],
            };
        case types.SET_POPOVER_STATUS:
            return {
                ...state,
                popoverStatus: {
                    ...action.payload,
                },
            };
        case types.OPEN_LIGHT_POPUP:
            return {
                ...state,
                lightPopup: payload.name,
                lightPopupData: payload,
                ...(payload.content ? { lightPopupContent: payload.content } : {}),
            };

        case types.CLOSE_LIGHT_POPUP:
            return { ...state, lightPopup: null };

        default:
            return state;
    }
};

export default reducers;
